import { AnyAction, applyMiddleware, legacy_createStore as createStore, Dispatch, Middleware } from "redux";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import reducers from "./reducers";

const logger = createLogger({
    duration: true,
    collapsed: true,
}) as Middleware<{}, any, Dispatch<AnyAction>>;

const middlewares: Middleware[] = [thunk];
if (process.env.APP_ENV !== "production") {
    middlewares.push(logger);
}

const store = createStore(reducers, applyMiddleware(...middlewares));

export default store;
